import $ from 'jquery';

const MobileMenu = (el) => {
    const $el = $(el);
    const nav = document.getElementById('js-nav');

    $el.on('click', function (e) {
        e.preventDefault();

        $('body').toggleClass('js-state-menu-open');

        if ($('body').hasClass('js-state-menu-open')) {
            nav.classList.add('opening');
            $('.burger').removeClass('burger--closed');
        } else {
            nav.classList.add('closing');
            $('.burger').addClass('burger--closed');
        }
    });

    nav.addEventListener('transitionend', () => {
        nav.classList.remove('opening');
        nav.classList.remove('closing');

        // if (!$('body').hasClass('js-state-menu-open')) {
        //     nav.classList.add('closing');
        // } else {
        //     nav.classList.remove('opening');
        // }
    });
};

export default MobileMenu;
